import React from "react";
import "./AvatarFeed.css";

interface AvatarFeedProps {
  src?: string;
  alt?: string;
}

const AvatarFeed: React.FC<AvatarFeedProps> = ({ src, alt = "Imagem" }) => {
  const initials = (alt || "MC")
    .trim()
    .split(/\s+/)
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  return (
    <div className="feed-user-avatar">
      {src ? (
        <img src={src} alt={alt} />
      ) : (
        <span className="avatar-fallback">{initials}</span>
      )}
    </div>
  );
};

export default AvatarFeed;
